import React, { useEffect } from 'react';
const ICACTEA = () => {
  useEffect(() => {
    window.location.href = 'https://aec.edu.in/icmes2025/';
  }, [])
  return (
  <></>    
  )
}

export default ICACTEA;


